import type { OpsPriority, WaitingOn, WorkflowStage } from './types';

export const WORKFLOW_STAGE_LABEL: Record<WorkflowStage, string> = {
  new_order: 'Nuevo',
  collecting_data: 'Recabando datos',
  ready_to_submit: 'Listo para presentar',
  fee_pending: 'Tasa pendiente',
  fee_paid: 'Tasa pagada',
  submitted: 'Presentada',
  awaiting_administration: 'Espera Administración',
  requirement_received: 'Requerimiento',
  license_received: 'Licencia recibida',
  ready_to_deliver: 'Lista para entregar',
  delivered: 'Entregada',
  blocked: 'Bloqueada',
  cancelled: 'Cancelada',
};

export const WAITING_ON_LABEL: Record<WaitingOn, string> = {
  us: 'AiPeces',
  alberto: 'Alberto',
  client: 'Cliente',
  administration: 'Administración',
  none: 'Nadie',
};

export const PRIORITY_LABEL: Record<OpsPriority, string> = {
  normal: 'Normal',
  urgent: 'Urgente',
};

export const MILESTONE_LABEL: Record<string, string> = {
  created: 'Creado',
  client_paid: 'Cliente pagó',
  fee_paid: 'Tasa oficial',
  submitted: 'Presentada',
  license_received: 'Licencia recibida',
};

export const CHECKLIST_LABELS: Array<{ key: string; label: string }> = [
  { key: 'personal_data_complete', label: 'Datos personales completos' },
  { key: 'id_document_received', label: 'DNI/NIE o documento extranjero recibido' },
  { key: 'power_of_attorney_signed', label: 'Poder de representación firmado' },
  { key: 'client_payment_received', label: 'Pago del cliente recibido' },
  { key: 'duplicates_checked', label: 'Posibles duplicados comprobados' },
  { key: 'official_fee_paid', label: 'Tasa oficial pagada' },
  { key: 'official_fee_receipt_archived', label: 'Justificante del pago archivado' },
  { key: 'request_submitted', label: 'Solicitud presentada' },
  { key: 'submission_receipt_archived', label: 'Justificante de registro archivado' },
  { key: 'client_informed_submission', label: 'Cliente informado de la presentación' },
  { key: 'requirement_reviewed', label: 'Requerimiento administrativo revisado' },
  { key: 'license_definitive_received', label: 'Licencia definitiva recibida' },
  { key: 'leaflet_attached', label: 'Folleto correcto adjunto' },
  { key: 'final_email_sent', label: 'Correo final enviado' },
  { key: 'final_whatsapp_sent', label: 'WhatsApp final enviado' },
  { key: 'pro_coupon_included', label: 'Cupón Pro incluido' },
  { key: 'expiry_control_created', label: 'Control de caducidad creado' },
  { key: 'order_delivered_in_portal', label: 'Pedido entregado en el Portal' },
];

export function daysUntilReview(iso: string | null): string {
  if (!iso) return '—';
  const ms = new Date(iso).getTime() - Date.now();
  const days = Math.ceil(ms / (24 * 60 * 60 * 1000));
  if (days < 0) return `Vencido ${Math.abs(days)}d`;
  if (days === 0) return 'Hoy';
  return `${days}d`;
}
